var React = require('react');

function So (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-85.3 0h682.6v512H-85.3z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","transform":"translate(80) scale(.9375)","key":1},[React.createElement("path",{"fill":"#40a6ff","d":"M-128 0h768v512h-768z","key":0}),React.createElement("path",{"fill":"#fff","d":"M336.5 381.2L254 327.7l-82.1 54 30.5-87.7-82-54.2L222 239l31.4-87.5 32.1 87.3 101.4.1-81.5 54.7 31.2 87.6z","key":1})])]);
}

So.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = So;

So.default = So;
